import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { api } from "../lib/api";

export default function Insights() {
  const { t, lang } = useI18n();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="insights-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
      <div className="grid lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-7">
          <p className="eyebrow">{t.blog.eyebrow}</p>
          <h1 className="font-display text-5xl lg:text-6xl mt-4 leading-[1.0] tracking-tight">
            {t.blog.title}
          </h1>
        </div>
      </div>

      <div className="grid lg:grid-cols-12 gap-px bg-slate-200 border border-slate-200">
        {posts.map((p, i) => (
          <Link
            to={`/insights/${p.slug}`}
            key={p.slug}
            data-testid={`post-card-${p.slug}`}
            className={`bg-white p-10 lg:p-14 hover:bg-slate-50 transition-colors lg:col-span-6 ${
              i === 0 ? "lg:col-span-12" : ""
            }`}
          >
            <p className="eyebrow">
              {p.category} · {p.read_minutes} {t.blog.minutes}
            </p>
            <h2
              className={`font-display mt-4 leading-tight tracking-tight ${
                i === 0 ? "text-4xl lg:text-5xl" : "text-2xl lg:text-3xl"
              }`}
            >
              {lang === "ar" ? p.title_ar : p.title_en}
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">
              {lang === "ar" ? p.excerpt_ar : p.excerpt_en}
            </p>
            <p className="mt-6 text-sm text-slate-500">{p.author} · {p.published_at}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
